/* Workflows — the executable layer. Same ONE loop + the strongest Try:
 * request→response in isolation (BUILD-JOURNEY stage 2). */
import React, {
    useState
} from 'react';
import {
    useSearchParams
} from 'react-router-dom';
import {
    Play
} from 'lucide-react';
import CopyPackButton from '../../shared/CopyPackButton';
import DefEditorScreen from '../../shared/DefEditorScreen';
import DefWorkbench from '../../shared/DefWorkbench';
import NewDefButton from '../../shared/NewDefButton';
import WorkflowPipeline from '../../shared/visuals/WorkflowPipeline';
import TryDrawer from './TryDrawer';

function WorkflowDetail({
    id,
    onChanged
}: {
    id: string;
    onChanged: () => void;
}) {
    const [tryOpen, setTryOpen] = useState(false);
    const [docText, setDocText] = useState('');
    return (
        <>
            <DefEditorScreen
                type="workflow"
                id={id}
                onDeleted={onChanged}
                visual={(text) => <WorkflowPipeline docText={text} />}
                actions={(text) => (
                    <>
                        <CopyPackButton stage="workflows" currentDoc={{
                            label: `workflow ${id}`,
                            text
                        }} />
                        <button className="aps-btn aps-btn-secondary aps-btn-sm"
                            title="Test-execute with a sample input"
                            onClick={() => {
                                setDocText(text);
                                setTryOpen(true);
                            }}>
                            <Play size={14} />
                            Try
                        </button>
                    </>
                )}
            />
            {tryOpen && (
                <TryDrawer
                    workflowId={id}
                    workflowText={docText}
                    onClose={() => setTryOpen(false)}
                />
            )}
        </>
    );
}

export default function WorkflowsPage() {
    const [listVersion, setListVersion] = useState(0);
    const [search, setSearch] = useSearchParams();
    // After a POST-create the engine returns the MINTED id — open the
    // editor on it straight away (selection lives in ?id=).
    const openCreated = (id: string) => {
        setListVersion((v) => v + 1);
        const next = new URLSearchParams(search);
        next.set('id', id);
        setSearch(next);
    };
    return (
        <DefWorkbench
            type="workflow"
            title="Workflows"
            subtitle="Machine-only steps over capabilities — pure JSON out"
            emptyHint="Paste a workflow JSON into a new document, or start from wf_sign_in."
            listVersion={listVersion}
            headActions={(
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 6
                }}>
                    <NewDefButton type="workflow" onCreated={openCreated} />
                    <CopyPackButton stage="workflows" block />
                </div>
            )}
            renderDetail={(id) => (
                <WorkflowDetail id={id} onChanged={() => setListVersion((v) => v + 1)} />
            )}
        />
    );
}
